// Utilities for communicating with the native webview.
import { undefA } from './stdtypes';
import { getIsInAndroid, getIsInIOS } from './util';

export const requestAppLogin = () => {
    sendMessageToContainer('login');
};

export const requestAppClosePanel = () => {
    sendMessageToContainer('closePanel');
};

export const requestAppNavigateToExternalUrl = (url) => {
    sendMessageToContainer('navigateTo', url);
};

export type NativeWindow = {
    parent: any;
    webkit?: {
        messageHandlers?: Record<string, any>;
    };
    Android?: any;
};

export function sendMessageToContainer(action: string, params = undefA) {
    const nativeWindow = window as NativeWindow;
    if (getIsInIOS(nativeWindow)) {
        nativeWindow.webkit?.messageHandlers?.[action].postMessage(params);
    } else if (getIsInAndroid(nativeWindow)) {
        nativeWindow.Android?.[action](params);
    }
}
